import { render, staticRenderFns } from "./PesquisasAnswer.vue?vue&type=template&id=7a1bd629&"
import script from "./PesquisasAnswer.vue?vue&type=script&lang=js&"
export * from "./PesquisasAnswer.vue?vue&type=script&lang=js&"
import style0 from "./PesquisasAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports